import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

export const api = axios.create({
  baseURL,
  timeout: 15000,
  headers: { Accept: 'application/json' },
});

const get = (path, params) => api.get(path, { params }).then((r) => r.data);
const post = (path, body) => api.post(path, body).then((r) => r.data);

// ---- public reads ----
export const fetchSlides = () => get('/slides');
export const fetchStats = () => get('/stats');
export const fetchFeatures = () => get('/features');
export const fetchLevelCards = () => get('/level-cards');
export const fetchAddresses = () => get('/addresses');
export const fetchPartners = () => get('/partners');
export const fetchLeadershipMessages = () => get('/leadership-messages');
export const fetchFaculty = () => get('/faculty');
export const fetchAlumni = () => get('/alumni');
export const fetchCalendar = () => get('/calendar');
export const fetchCareers = () => get('/careers');

export const fetchNews = (params) => get('/news', params);
export const fetchNewsBySlug = (slug) => get(`/news/${encodeURIComponent(slug)}`);
export const fetchEvents = (params) => get('/events', params);
export const fetchAchievements = (params) => get('/achievements', params);

export const fetchGalleryAlbums = () => get('/gallery/albums');
export const fetchGalleryAlbum = (slug) => get(`/gallery/albums/${encodeURIComponent(slug)}`);

export const fetchPage = (slug) => get(`/pages/${encodeURIComponent(slug)}`);
export const fetchSiteSettings = () => get('/site-settings');
export const fetchMenuItems = () => get('/menu-items');
export const fetchCampuses = () => get('/campuses');
export const fetchFacilities = () => get('/facilities');
export const fetchHomeWelcome = () => get('/home-welcome');
export const fetchHomeAdvantage = () => get('/home-advantage');
export const fetchHomePopup = () => get('/home-popup');
export const fetchAdmissionClasses = () => get('/admission-classes');

// ---- public writes (form submissions) ----
export const submitEnquiry = (body) => post('/enquiries', body);
export const submitContact = (body) => post('/contact', body);
export const submitAlumniRegistration = (body) => post('/alumni-registration', body);
export const subscribeNewsletter = (email) => post('/newsletter', { email });
